export default {
  levelPrivilege: '等級權益',
  levelPrivilegeDesc:
    '等級權益是基於用戶在社區的活躍情況而獲取的積分所決定，達到相應積分的即可升級。等級從低到高依次為註冊用戶、L1、L2。等級越高，享受的權益越多。 ',
  userGetPointsWayTitle: '用戶獲取積分升級的方式',
  above: '以上',
  registeredUser: '註冊用戶',
  points: '積分',
  level: '級別',
  privilege: '權益',
  userLevelDivision: '用戶等級劃分',
  userUpgradeDowngrade: '用戶升降級',
  userUpgradeDowngradeDesc:
    '系統會實時更新用戶的累計積分，達到晉級條件的，直接升入對應等級，用戶晉級不沖減積分。用戶的級別永久有效，但會有相關處罰措施，違返平台規則的將扣減200以上不等的積分，當積分下降到低於當前等級要求時即會降級處理。 ',
  levelPrivilegeTips: '* 平台會根據業務需求對等級權益進行增減，相關調整後不會額外通知。 '
}
